import { useEffect, useState } from 'react';
import { publicApi } from './api';

// Simple global cache so each page doesn't re-fetch
let cachedContent = null;
let inFlight = null;
const subscribers = new Set();

function notify(content) {
  subscribers.forEach((cb) => {
    try { cb(content); } catch (_) {}
  });
}

export function refreshSiteContent() {
  inFlight = publicApi.getSiteContent().then((res) => {
    cachedContent = res.data || {};
    inFlight = null;
    notify(cachedContent);
    return cachedContent;
  }).catch(() => {
    inFlight = null;
    return cachedContent || {};
  });
  return inFlight;
}

export function useSiteContent() {
  const [content, setContent] = useState(cachedContent || {});

  useEffect(() => {
    const cb = (c) => setContent({ ...c });
    subscribers.add(cb);
    if (!cachedContent && !inFlight) {
      refreshSiteContent();
    } else if (cachedContent) {
      setContent({ ...cachedContent });
    }
    return () => subscribers.delete(cb);
  }, []);

  // Helper to get a text value with fallback
  // IMPORTANT: an empty string is a valid value (means "hide this field"),
  // so we only fall back when the value is explicitly missing.
  const tx = (key, fallback = '') => {
    const value = content[key];
    return (value === undefined || value === null) ? fallback : value;
  };

  return { content, tx };
}
